import { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './EmptyInsights.module.scss';

import ImageEmpty from 'app/assets/images/personal/insights.png';

function EmptyInsights(): ReactElement {
  return (
    <div className={styles.wrapper}>
      <img width={581} height={525} src={ImageEmpty} alt="Empty insights" />
      <p>
        <FormattedMessage
          id={'personal.insights.empty.text'}
          defaultMessage={'All tours views will be displayed here'}
        />
      </p>
    </div>
  );
}

export default EmptyInsights;
